// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: [
    {
      title: 'Статусы',
      isSortable: false,
      allActive: false
    }
  ],
  statuses: [
  ],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: { type: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractsStatusList: state => state.statuses,
  getContractsStatusListTableHeaders: state => state.tableHeaders,
  getContractsStatusListModal: state => state.modal,
  getContractsStatusListSearchValue: state => state.searchValue,
  getContractsStatusListFilter: state => state.filter,
  getContractsStatusListPagination: state => state.pagination,
  toggleContractsStatusListPageList: state => state.pagination,
  getContractStatusListIsLoading: state => state.isLoading,
  getContractsStatusListResponseModal: state => state.responseModal,
  getContractsStatusListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractsStatusListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTS_STATUSES: (state, statuses) => {
    state.statuses = statuses.map(status => {
      return {
        ...status,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTS_STATUS_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  SHOW_CONTRACTS_STATUS_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedStatus = state.statuses.filter(status => {
        return status.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedStatus.name
      state.modal.color = selectedStatus.color
    }
  },
  SET_CONTRACTS_STATUS_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTS_STATUS_ITEM_VALIDATION: (state, valid) => {
    state.modal.validation.name.message = valid.name[0]
    state.modal.validation.name.type = 'error'
  },
  CLEAR_CONTRACTS_STATUS_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTS_STATUS_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = { type: null, message: '' }
  },

  // pagination
  SET_CONTRACTS_STATUS_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTS_STATUS_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACTS_STATUS_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_CONTRACTS_STATUS_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  DELETE_CONTRACTS_STATUS_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили статус(ы)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTS_STATUS_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении статуса произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  DELETE_CONTRACTS_STATUS_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные статусы используются в договорах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACTS_STATUS_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACTS_STATUS_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  TOGGLE_CONTRACTS_STATUS_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.statuses.length
    let counter = 0

    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTS_STATUS_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.statuses.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_CONTRACTS_STATUS_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.statuses.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACTS_STATUS_LIST_STORE: (state) => {
    state.searchValue = ''
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractsStatus ({ commit, state }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''

    axios.get(`${url}/treaties-status?expand=treaties&${searchFilter}&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_STATUSES', response.data.data)
      commit('SET_CONTRACTS_STATUS_LIST_PAGINATION', response.headers)
      state.isLoading = false
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  saveContractsStatusItem ({ commit, state, dispatch }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name
      }
      axios.post(`${url}/treaties-status`, createData, config).then(response => {
        commit('CLOSE_CONTRACTS_STATUS_LIST_MODAL')
        dispatch('getContractsStatus')
        dispatch('getContractsStatus')
      }).catch(error => {
        commit('SET_CONTRACTS_STATUS_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    } else {
      const updateData = {
        name: state.modal.name
      }

      axios.put(`${url}/treaties-status/${state.modal.updatedId}`, updateData, config).then(response => {
        commit('CLOSE_CONTRACTS_STATUS_LIST_MODAL')
        dispatch('getContractsStatus')
      }).catch(error => {
        commit('SET_CONTRACTS_STATUS_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    }
  },
  toggleContractsStatusListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_STATUS_LIST_ITEM_CONTROLS', itemId)
  },
  closeContractsStatusListItemControls ({ commit }, itemId) {
    commit('CLOSE_CONTRACTS_STATUS_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractsStatusListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_STATUS_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractsStatusListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTS_STATUS_LIST_ITEM_ACTIVE_ALL')
  },
  showContractsStatusModal ({ commit }, itemId) {
    commit('SHOW_CONTRACTS_STATUS_LIST_MODAL', itemId)
  },
  setContractsStatusItemName ({ commit }, value) {
    commit('SET_CONTRACTS_STATUS_ITEM_NAME', value)
  },
  clearContractsStatusModalValidation ({ commit }, inputName) {
    commit('CLEAR_CONTRACTS_STATUS_MODAL_VALIDATION', inputName)
  },
  closeContractsStatusModal ({ commit }) {
    commit('CLOSE_CONTRACTS_STATUS_LIST_MODAL')
  },
  removeContractsStatus ({ dispatch }, itemId) {
    axios.delete(`${url}/treaties-status/${itemId}`, config).then(response => {
      dispatch('getContractsStatus')
    }).catch(error => {
      console.log('Ошибка удаления статуса:' + error)
    })
  },

  // pagination
  getContractsStatusListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/treaties-status?${searchFilter}&orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_STATUSES', response.data.data)
      commit('SET_CONTRACTS_STATUS_LIST_PAGINATION', response.headers)
      commit('CLOSE_CONTRACTS_STATUS_LIST_PAGE_LIST')
    })
  },
  resetContractsStatusListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTS_STATUS_LIST_CURRENT_PAGE')
  },

  // search
  setContractsStatusListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTS_STATUS_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTS_STATUS_LIST_CURRENT_PAGE')
    dispatch('getContractsStatus')
  },

  // delete checked items
  deleteContractsStatusListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []
    state.statuses.forEach((e) => {
      if (e.isActive && e.treaties === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.treaties) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACTS_STATUS_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/treaties-status/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления статуса', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('RESET_CONTRACTS_STATUS_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTS_STATUS_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractsStatus')
        } else {
          commit('RESET_CONTRACTS_STATUS_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTS_STATUS_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractsStatus')
        }
      })
    }
  },
  closeContractsStatusListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_STATUS_LIST_MODAL')
  },
  closeContractsStatusListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_STATUS_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
